import React, { useEffect } from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';

interface LightboxProps {
    imageUrl: string;
    isOpen: boolean;
    onClose: () => void;
}

const Lightbox: React.FC<LightboxProps> = ({ imageUrl, isOpen, onClose }) => {
    const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
        // Close lightbox when clicking on the overlay (not the image)
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    useEffect(() => {
        const handleKeyDown = (e: KeyboardEvent) => {
            if (e.key === 'Escape') {
                onClose();
            }
        };

        if (isOpen) {
            document.addEventListener('keydown', handleKeyDown);
            // Prevent body scroll when lightbox is open
            document.body.style.overflow = 'hidden';
        }

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
            document.body.style.overflow = 'unset';
        };
    }, [onClose, isOpen]);

    return (
        <div
            className="fixed inset-0 bg-black bg-opacity-90 flex items-center justify-center z-50"
            onClick={handleOverlayClick}
        >
            {/* Close button */}
            <button
                onClick={onClose}
                className="absolute top-4 right-4 text-white hover:text-gray-300 transition-colors duration-200 z-10"
                aria-label="Close lightbox"
            >
                <XMarkIcon className="w-8 h-8" />
            </button>

            {/* Image container */}
            <div className="max-w-[95vw] max-h-[95vh] flex items-center justify-center">
                <img
                    src={imageUrl}
                    alt="Lightbox image"
                    className="max-w-full max-h-full object-contain"
                    style={{ maxWidth: '95vw', maxHeight: '95vh' }}
                />
            </div>
        </div>
    );
};
export default Lightbox;